export const TOGGLE_DOWNLOAD_REPORT_DISABLE = 'TOGGLE_DOWNLOAD_REPORT_DISABLE';
export const RESET_SUCCESS_OPERATION_MESSAGE = 'RESET_SUCCESS_OPERATION_MESSAGE';
export const CHANGE_TOP_LEVEL_DOMAIN_LIST_OPTIONS = 'CHANGE_TOP_LEVEL_DOMAIN_LIST_OPTIONS';
export const LOAD_TOP_LEVEL_DOMAINS = 'LOAD_TOP_LEVEL_DOMAINS';
export const UPDATE_SELECTED_TOP_LEVEL_DOMAINS = 'UPDATE_SELECTED_TOP_LEVEL_DOMAINS';
export const LOAD_INFRASTRUCTURE = 'LOAD_INFRASTRUCTURE';
export const UPDATE_SELECTED_INFRASTRUCTURE = 'UPDATE_SELECTED_INFRASTRUCTURE';
export const CHANGE_INFRASTRUCTURE_LIST_OPTIONS = 'CHANGE_INFRASTRUCTURE_LIST_OPTIONS';
export const CHANGE_LEAKS_LIST_OPTIONS = 'CHANGE_LEAKS_LIST_OPTIONS';
export const LOAD_LEAKS = 'LOAD_LEAKS';
export const UPDATE_DATA_LEAKS_ITEMS = 'UPDATE_DATA_LEAKS_ITEMS';
export const CHANGE_EMPLOYEES_LIST_OPTIONS = 'CHANGE_EMPLOYEES_LIST_OPTIONS';
export const LOAD_EMPLOYEES = 'LOAD_EMPLOYEES';
export const UPDATE_SELECTED_EMPLOYEES = 'UPDATE_SELECTED_EMPLOYEES';
export const CHANGE_TECHNOLOGIES_LIST_OPTIONS = 'CHANGE_TECHNOLOGIES_LIST_OPTIONS';
export const LOAD_TECHNOLOGIES = 'LOAD_TECHNOLOGIES';
export const LOAD_PASSWORD_SPRAY_STATS_UPDATED = 'LOAD_PASSWORD_SPRAY_STATS_UPDATED';
export const CHANGE_CLOUD_INSTANCES_LIST_OPTIONS = 'CHANGE_CLOUD_INSTANCES_LIST_OPTIONS';
export const LOAD_CLOUD_INSTANCES = 'LOAD_CLOUD_INSTANCES';
export const UPDATE_SELECTED_CLOUD_INSTANCES = 'UPDATE_SELECTED_CLOUD_INSTANCES';
export const CHANGE_CLOUD_BUCKETS_LIST_OPTIONS = 'CHANGE_CLOUD_BUCKETS_LIST_OPTIONS';
export const LOAD_CLOUD_BUCKETS = 'LOAD_CLOUD_BUCKETS';
export const UPDATE_SELECTED_CLOUD_BUCKETS = 'UPDATE_SELECTED_CLOUD_BUCKETS';
export const SET_CLOUD_INSTANCES_LOADING = 'SET_CLOUD_INSTANCES_LOADING';
export const SET_CLOUD_BUCKETS_LOADING = 'SET_CLOUD_BUCKETS_LOADING';
export const SET_CLOUD_SERVICES_LOADING = 'SET_CLOUD_SERVICES_LOADING';
export const CHANGE_INFOSTEALERS_LIST_OPTIONS = 'CHANGE_INFOSTEALERS_LIST_OPTIONS';
export const LOAD_INFOSTEALERS = 'LOAD_INFOSTEALERS';
export const SET_INFOSTEALERS_LIST_OPTIONS = 'SET_INFOSTEALERS_LIST_OPTIONS';
export const SET_INFOSTEALERS_LOADING = 'SET_INFOSTEALERS_LOADING';
export const SET_INFOSTEALERS_FILTERS = 'SET_INFOSTEALERS_FILTERS';
export const SET_INFOSTEALERS_ITEMS = 'SET_INFOSTEALERS_ITEMS';
export const SET_INFOSTEALERS_PAGINATION_STATE = 'SET_INFOSTEALERS_PAGINATION_STATE';
export const CLEAR_INFOSTEALERS_ITEMS = 'CLEAR_INFOSTEALERS_ITEMS';
export const CLEAR_INFOSTEALERS_CACHE = 'CLEAR_INFOSTEALERS_CACHE';
export const CLEAR_INFOSTEALERS_BACKEND_CACHE = 'CLEAR_INFOSTEALERS_BACKEND_CACHE';
export const LOAD_INFOSTEALERS_PROGRESS = 'LOAD_INFOSTEALERS_PROGRESS';
export const START_INFOSTEALERS_POLLING = 'START_INFOSTEALERS_POLLING';
export const STOP_INFOSTEALERS_POLLING = 'STOP_INFOSTEALERS_POLLING';
export const CLEAR_TOP_LEVEL_DOMAINS_CACHE = 'CLEAR_TOP_LEVEL_DOMAINS_CACHE';
